module.exports = __webpack_public_path__ + "static/deszcz-3b139843c1ceacb278b5af253b507c5d.svg";